














































































































































import _ from 'lodash';
// eslint-disable-next-line no-unused-vars
import { DropdownItem } from '@/main/store/@types/dropdown.d';
// eslint-disable-next-line no-unused-vars
import { convertToObjects, Row } from '@/main/utils/table';
import { editFactory } from '@/main/pages/editFactory';
import { TABLE_SCHEMA_DATA } from '@/main/store/listEditTypes';

import DmsEditableTable from '#components/dms/layout/EditableTable.vue';

import { NAME, POLOZKY, ND_PRIJEMKA, POLOZKY_COLS, POLOZKY_COLS_EDIT_FLAG } from './constants';
import { apiProvider as ndPrijemkaApiProvider } from '../ndPrijemka/api';
import { store } from './store/edit';

export default editFactory(NAME, store).extend({
	components: {
		DmsEditableTable,
	},
	data() {
		return {
			dependencies: { POLOZKY, ND_PRIJEMKA },
			polozkyCols: POLOZKY_COLS,
		};
	},
	created() {
		this.mainCollapse = ['1', '2'];
	},
	methods: {
		getDropdownText(dropdownList: DropdownItem[], value: any) {
			return dropdownList.find((item: DropdownItem) => item.Value === value)?.Text;
		},
		canEditRow(row: Row) {
			const flagsColumnIndex = this.dependentTables.Polozky.cellNames?.FLAGS;
			return _.isNil(flagsColumnIndex) ? false : !!row.cells[flagsColumnIndex];
		},
		hasCellEditFlag(row: Row, columnName: string) {
			const flagsColumnIndex = this.dependentTables.Polozky.cellNames!.FLAGS;
			const flags = row.cells[flagsColumnIndex];
			const columnFlag = _.get(POLOZKY_COLS_EDIT_FLAG, columnName);
			/* eslint-disable no-bitwise */
			return flags & columnFlag;
		},
		async loadData() {
			await this.entity();
			await this.loadedData();
			this.fetchTableSchemas(this.dependeciesByFilter);
			this.fetchTableData(this.dependeciesByFilter);
			this.fetchTableSchemaData(this.dependenciesById);
		},
		async save(goBack = true) {
			const isValid = await this.validate();
			if (!isValid) {
				throw new Error('Data are not valid');
			}
			this.Polozky = convertToObjects(this.dependentTables.Polozky) as [];
			return this.update(goBack);
		},
		async edl2NdPrijemka() {
			try {
				this.startLoading();
				await this.save(false);
				const res = await ndPrijemkaApiProvider.edl2NdPrijemka(this.EdlId!);
				if (res && res.data) {
					await this.refreshNdPrijemka();
					// Polozky se refreshuji kvuli updatu FLAGu v datech. V budoucnu se prida PrevedenoPrp do editu enitity a upravi logika.
					await this.refreshTable(POLOZKY);
				}
			} finally {
				this.endLoading();
			}
		},
		async refreshNdPrijemka() {
			return this.$store.dispatch(`${this.storeUri}/${ND_PRIJEMKA}_${TABLE_SCHEMA_DATA}`);
		},
		updateSkladOzn(updateCol: Function, newValue: number, columnId: string) {
			updateCol(newValue, this.dependentTables.Polozky.cellNames![POLOZKY_COLS.SKLAD_OZN]);
			updateCol(this.getDropdownText(this.dropdownList.SkladOzn, newValue), columnId);
		},
		updateVyrobekOzn(updateCol: Function, newValue: string, columnId: string) {
			updateCol(newValue, this.dependentTables.Polozky.cellNames![POLOZKY_COLS.VYROBEKND_OZN]);
			updateCol(this.getDropdownText(this.dropdownList.VyrobekndOzn, newValue), columnId);
		},
	},
});
